import {
	readSqSidCookie,
	writeSqSidCookie,
} from "@analytics/lib/identity-cookie";
import { orpcClient } from "@shared/lib/orpc-client";

export async function syncAuthIdentityCookieAndVisitor(
	userSqid: string,
): Promise<void> {
	const visitorSqid = readSqSidCookie() ?? undefined;
	const result = await orpcClient.identity.reconcileAuthVisitor({
		visitorSqid,
	});
	writeSqSidCookie(result.sqid || userSqid);
}
